import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import * as React from 'react';
import {useState} from 'react';
import TextField from '@mui/material/TextField';

export default function WordleInput() {
  const [selectedWord, setSelectedWord] = useState('5')

  const handleChange = (event) => {
    setSelectedWord(event.target.value)
  }
  return <>
    <FormControl>
      <FormLabel id="demo-row-radio-buttons-group-label">Letters in word</FormLabel>
      <RadioGroup

        row
        aria-labelledby="letters-in-word-label"
        name="letters-in-word"
        defaultValue={selectedWord}
        onChange={handleChange}
      >
        <FormControlLabel value="4" control={<Radio/>} label="4"/>
        <FormControlLabel value="5" control={<Radio/>} label="5"/>
        <FormControlLabel value="6" control={<Radio/>} label="6"/>
      </RadioGroup>
    </FormControl>
    <TextField id="wordle-word" fullWidth={true} inputProps={{ minLength: selectedWord, maxLength: selectedWord }}
               label={`Type your ${selectedWord} letter word`} variant="outlined"/>
  </>
}